import { FC } from 'react'
import styled, { css } from 'styled-components'

interface IFProps {
  label: string
}

const PredictionFormLabel: FC<IFProps> = ({ label }) => {
  return <StyledWrapper>{label}</StyledWrapper>
}

export default PredictionFormLabel

const StyledWrapper = styled.p`
  ${({ theme }) => css`
    display: flex;
    flex-shrink: 0;
    font-size: 16px;
    color: ${theme.color.text_1};
    letter-spacing: -0.64px;
    font-weight: bold;
    text-align: left;
  `}
`
